<template>
  <aside class="blog-sidebar">
    <div class="widget text-center">
      <div id="devis-3d">
        <a href="https://mon-devis.deck-linea.com/devis/garde-corps?utm_source=www.oxynov.fr" target="_blank">
          <img src="/static/images/aside/devis-garde-corps-inox.jpg" alt="devis garde corps inox">
        </a>
        <a href="https://mon-devis.deck-linea.com/devis/garde-corps?utm_source=www.oxynov.fr" target="_blank" class="btn btn-primary btn-outlined">
          Lancer le devis 3D
        </a>
      </div>
      <p>Spécialiste du <strong>garde-corps INOX</strong>, OXYNOV a développé pour vous une gamme de <strong>garde-corps inox en kit</strong> au meilleur prix. Dessinez votre <strong>garde-corps en 3D</strong> et <strong>calculez votre devis en ligne</strong> grâce au calculateur Oxynov-3D</p>
    </div>
    <div class="widget">
      <h3>Galerie photo</h3>
      <ul id="aside-gallery" @click="openGallery('aside-gallery', $event)">
        <li>
          <a href="/static/images/aside/zoom/coin-garde-corps-inox-tubes-min.jpg" class="zoom" title="garde corps et terrasse">
            <img src="/static/images/aside/coin-garde-corps-inox-tubes-min.jpg" alt="garde corps inox sur terrasse">
          </a>
        </li>
        <li>
          <a href="/static/images/aside/zoom/coude-articule-inox-main-courante-min.jpg" class="zoom" title="balustrade inox">
            <img src="/static/images/aside/coude-articule-inox-main-courante-min.jpg" alt="coude de balustrade inox">
          </a>
        </li>
        <li>
          <a href="/static/images/aside/zoom/fixation-tubes-remplissage-inox-min.jpg" class="zoom" title="tube inox de garde corps">
            <img src="/static/images/aside/fixation-tubes-remplissage-inox-min.jpg" alt="tube inox pour remplissage garde-corps">
          </a>
        </li>
        <li>
          <a href="/static/images/aside/zoom/garde-corps-main-courante-bois-tubes1-min.jpg" class="zoom" title="main courante en bois">
            <img src="/static/images/aside/garde-corps-main-courante-bois-tubes1-min.jpg" alt="main courante en bois">
          </a>
        </li>
        <li>
          <a href="/static/images/aside/zoom/garde-corps-inox-contour-terrasse-min.jpg" class="zoom" title="contour d'une terrasse avec un garde corps">
            <img src="/static/images/aside/garde-corps-inox-contour-terrasse-min.jpg" alt="contour de terrasse en inox">
          </a>
        </li>
        <li>
          <a href="/static/images/aside/zoom/garde-corps-inox-main-courante-bois-min.jpg" class="zoom" title="garde corps inox et bois">
            <img src="/static/images/aside/garde-corps-inox-main-courante-bois-min.jpg" alt="main courante en bois, rampe">
          </a>
        </li>
        <li>
          <a href="/static/images/aside/zoom/garde-corps-main-courante-bois-min.jpg" class="zoom" title="main courante inox et bois">
            <img src="/static/images/aside/garde-corps-main-courante-bois-min.jpg" alt="main courante bois pour garde-corps inox">
          </a>
        </li>
        <li>
          <a href="/static/images/aside/zoom/platines-murales-fixations-tubes-min.jpg" class="zoom" title="platine murale en inox">
            <img src="/static/images/aside/platines-murales-fixations-tubes-min.jpg" alt="platine murale de fixation de main courante">
          </a>
        </li>
        <li>
          <a href="/static/images/aside/zoom/garde-corps-inox-remplissage-cable-piscine1-min.jpg" class="zoom" title="garde-corps pour piscine">
            <img src="/static/images/aside/garde-corps-inox-remplissage-cable-piscine1-min.jpg" alt="garde-corps pour piscine">
          </a>
        </li>
        <li>
          <a href="/static/images/aside/zoom/poteaux-inox-garde-corps-min.jpg" class="zoom" title="poteaux pour balustrade">
            <img src="/static/images/aside/poteaux-inox-garde-corps-min.jpg" alt="poteaux en inox pour balustrade">
          </a>
        </li>
        <li>
          <a href="/static/images/aside/zoom/rampe-escalier-rambarde-inox-min.jpg" class="zoom" title="rampe d'escalier en inox">
            <img src="/static/images/aside/rampe-escalier-rambarde-inox-min.jpg" alt="rampe d'escalier inox">
          </a>
        </li>
        <li>
          <a href="/static/images/aside/zoom/garde-corps-inox-fenetre-min.jpg" class="zoom" title="garde corps pour fenêtre">
            <img src="/static/images/aside/garde-corps-inox-fenetre-min.jpg" alt="garde-corps inox fenetre">
          </a>
        </li>
      </ul>
    </div>
    <div class="widget">
      <h3>Les modèles</h3>
      <p>Le saviez vous ? Avec les produits OXYNOV une multitude de combinaisons est possible. <router-link to="/modeles" title="découvrir les modèles de garde-corps">Voir les modèles</router-link></p>
    </div>
    <div class="widget">
      <h3>L'installation</h3>
      <p>Vous souhaitez plus d'informations sur la pose et le montage de votre garde-corps INOX ? <router-link to="/installation" title="installer des garde-corps inox seul et facilement">Cliquez ici</router-link></p>
    </div>
    <div class="widget">
      <h3>Les types d'inox</h3>
      <p>Quelles sont les différences entre les inox 304 et 316 ? <router-link to="/inox-304-316" title="différence entre les 2 types d'inox 304 et 316">Cliquez ici</router-link></p>
    </div>
    <div class="widget">
      <h3>L'entretien de l'inox</h3>
      <p>Tout savoir sur l'entretien de votre garde-corps inox. <router-link to="/entretien" title="entretien de l'inox">Cliquez ici</router-link></p>
    </div>
    <modal name="modal-3d" :id="'modal-3d'" :width="960" :height="700" :clickToClose="false">
      <button @click="closeModal('modal-3d')" class="btn btn-link btn-close"><i class="fa fa-times"></i></button>
      <iframe src="https://www.oxynov.fr/devis" frameborder="0" scrolling="no" height="700" width="960"></iframe>
    </modal>
  </aside>
</template>

<script>
import { EventBus } from '@/event-bus.js'

export default {
  name: 'Aside',
  methods: {
    openGallery (id, event) {
      /* eslint-disable */
      event = event || window.event;
      var target = event.target || event.srcElement,
        link = target.src ? target.parentNode : target,
        options = {index: link, event: event},
        links = document.getElementById(id).querySelectorAll('a.zoom');
      blueimp.Gallery(links, options);
      event.preventDefault()
    },
    openModal (name) {
      EventBus.$emit('open-modal', 'modal-3d')
    }
  }
}
</script>

<style scoped>
aside .widget {
  margin-bottom: 30px;
}
aside #devis-3d img {
  box-shadow: 0 2px 5px 0 rgba(0,0,0,.26);
}
aside .widget .btn-outlined {
  border-color: #025d90;
  position: relative;
  top: -17px;
  box-shadow: 0 2px 5px 0 rgba(0,0,0,.26);
}
aside .widget .btn-link {
  margin-bottom: 10px;
}
aside h3 {
  font-size: 18px;
  border-bottom: dashed 1px #d4d4d4;
  padding-bottom: 15px;
  margin-bottom: 15px;
}
aside p {
  font-size: 13px;
}
aside #aside-gallery {
  list-style: none;
  display: inline-block;
  width: 100%;
}
aside #aside-gallery li {
  float: left;
  width: 23%;
  border: solid 5px #f7f7f7;
  margin: 0 1% 2% 1%;
}
aside #aside-gallery li:hover {
  border-color: #025d90;
}
aside #aside-gallery li a {
  display: block;
}
aside #aside-gallery li img {
  width: 100%;
}
aside p a {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/Aside.vue